module.exports = __webpack_public_path__ + "../../dist/Messanger/img/back.16138650.svg";